// extracted by mini-css-extract-plugin
export default {"CountContainer":"IFCount_CountContainer__aMpnL","Count":"IFCount_Count__UWGRA"};